/*
 * @author: liaosir
 */
import { APP_MODE } from 'ice';

const protocolStr = process.env.NODE_ENV === 'development' ? 'https:' : document.location.protocol;

const users = window.localStorage.getItem('user') ? JSON.parse(window.localStorage.getItem('user') || '') : '';

const getAcctivedAccountUrl = (username) => {
  return {
    dev: `${protocolStr}//usc-test.i4px.com/user/changemypwd2?username=${username}&redirectURL=${protocolStr}//giws-test.i4px.com/user/login&code=000`,
    test: `${protocolStr}//usc-test.i4px.com/user/changemypwd2?username=${username}&redirectURL=${protocolStr}//giws-test.i4px.com/user/login&code=000`,
    stage: `${protocolStr}//ucs.i4px.com/user/changemypwd2?username=${username}&redirectURL=${protocolStr}//giws-stage.i4px.com/user/login&code=000`,
    prod: `${protocolStr}//ucs.i4px.com/user/changemypwd2?username=${username}&redirectURL=${protocolStr}//giws.i4px.com/user/login&code=000`,
    eu: `${protocolStr}//ucs.eu.i4px.com/user/changemypwd2?username=${username}&redirectURL=${protocolStr}//giws.eu.i4px.com/user/login&code=000`,
    us: `${protocolStr}//ucs.us.i4px.com/user/changemypwd2?username=${username}&redirectURL=${protocolStr}//giws.us.i4px.com/user/login&code=000`,
    au: `${protocolStr}//ucs.au.i4px.com/user/changemypwd2?username=${username}&redirectURL=${protocolStr}//giws.au.i4px.com/user/login&code=000`,
    asia: `${protocolStr}//ucs.asia.i4px.com/user/changemypwd2?username=${username}&redirectURL=${protocolStr}//giws.asia.i4px.com/user/login&code=000`,
  }[APP_MODE];
};

/**
 * @description 登录cas地址
 */
const ACCTIVED_ACCOUNT_URL = getAcctivedAccountUrl(users?.empCode);

export { ACCTIVED_ACCOUNT_URL, getAcctivedAccountUrl };
